import { Box, Button, Chip, Divider, Grid, Paper, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { MSG_ERR_UNEXPECTED } from "../common/message";
import { CompanyPartHeader } from "../components/PartHeader";
import { postNewsSearchInfoListApi } from "../http/api/NewsApi";
import { CompanyTitledPage } from "./TitledPage";
import { getYearMonthDateDisplay } from "../utils/utils";

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const newsTitleStyle = {
  color: red[700],
}

const titleChipStyle = {
  marginLeft: 1,
  fontSize: 15,
  fontWeight: 'bold',
}

// 青果側　ホーム(お知らせ)ページ
export function CompanyHomePage() {

  const [newsListPageInfo, setNewsListPageInfo] = useState([]);
  
  useEffect(() => {
    (async () => {
      await setNewsListPage(1);
    })();
  }, []);

  const setNewsListPage = async (newsListPage) => {
    setNewsListPageInfo(await getNewsListPageInfo(newsListPage));
  }

  return (
    <CompanyTitledPage title="ホーム">
      <CompanyPartHeader>
        <Typography fontWeight="bold" fontSize={20}>
          お知らせ
        </Typography>
      </CompanyPartHeader>
      <PagingPart newsListPageInfo={newsListPageInfo} setNewsListPage={setNewsListPage} />
      <NewsListTable newsInfoList={newsListPageInfo.newsList}/>
      <PagingPart newsListPageInfo={newsListPageInfo} setNewsListPage={setNewsListPage} />
    </CompanyTitledPage>
  )
}

// お知らせ内容
function NewsContent({newsInfo}) {

  return (
    <Paper variant='elevation' elevation={3} sx={{marginBottom:2}}>
      <Box padding={2}>
        <Grid container spacing={2} alignItems='baseline'>
          <Grid item xs fontSize={20} fontWeight={600} {...newsTitleStyle}>
              {newsInfo.title}
          </Grid>
          <Grid item xs='auto'>
              {newsInfo.recentlyCreated ? <NewChip /> : null}
              {newsInfo.recentlyUpdated ? <UpdatedChip /> : null}
          </Grid>
          <Grid item xs='auto'>
            <Typography fontSize={16} textAlign='right' {...newsTitleStyle}>
              {getYearMonthDateDisplay(new Date(newsInfo.updatedAt))}
            </Typography>
          </Grid>
        </Grid>
        
        <Divider sx={{backgroundColor: red[600], marginY: 1}} />      
        <Typography whiteSpace='pre-wrap'>{`${newsInfo.contentText}`}</Typography>
      </Box>      
    </Paper>
  );
}

// NEWを表すChip
function NewChip() {
  return <Chip color='error' label='NEW!' sx={titleChipStyle}/>;
}

// UPDATEDを表すChip
function UpdatedChip() {
  return <Chip color='warning' label='UPDATED!' sx={titleChipStyle}/>;
}

// 種別を表すChip
function NewsTypeChip({newsTypeName}) {
  return <Chip color='primary' label={newsTypeName} sx={titleChipStyle}/>;
}

// お知らせ一覧
function NewsListTable({newsInfoList}) {
  if (newsInfoList && newsInfoList.length > 0) {
    return (
      <Box>
        {
          newsInfoList.map((newsInfo) => (
            <NewsContent newsInfo={newsInfo} />
          ))
        }
      </Box>
    );
  }

  return (
    <Typography>お知らせがありません。</Typography>
  );
  
}

// お知らせ一覧取得
const getNewsListPageInfo = async (newsListPage) => {
  try {
    let res = await postNewsSearchInfoListApi({newsListPage});
    return res.newsListPageInfo;
  } catch {
    alert(MSG_ERR_UNEXPECTED);
    return [];
  }
  
}

// ページング
function PagingPart({newsListPageInfo, setNewsListPage}) {

  const {newsListPage, newsCount, newsListCountPerPage} = newsListPageInfo;

  const disabledPrevPageButton = !newsListPage || newsListPage <= 1;
  const disabledNextPageButton = !newsListPage || (newsListPage * newsListCountPerPage >= newsCount);

  const onClickPrevPageButton = () => setNewsListPage(newsListPage - 1);
  const onClickNextPageButton = () => setNewsListPage(newsListPage + 1);

  return (
    <Grid container>
      <Grid item xs />
      <Grid item xs='auto'>
        <PrevPageButton onClick={onClickPrevPageButton} disabled={disabledPrevPageButton} />
      </Grid>
      <Grid item xs='auto'>
        <NextPageButton onClick={onClickNextPageButton} disabled={disabledNextPageButton}/>
      </Grid>
    </Grid>
  );  
}

// 前ページボタン
function PrevPageButton({onClick, disabled}) {
  return <Button onClick={onClick} disabled={disabled}><ArrowBackIosNewIcon />前ページ</Button>;
}

// 次ページボタン
function NextPageButton({onClick, disabled}) {
  return <Button onClick={onClick} disabled={disabled}>次ページ<ArrowForwardIosIcon /></Button>;
}